module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result02-be4e660b5ccb3de658abe0eedfe97b16.png";